import { Wifi, WifiOff, Loader2 } from 'lucide-react'
import { useWebSocket } from '@/hooks/useWebSocket'

// Check if WebSocket URL is explicitly configured
const wsConfigured = !!import.meta.env.VITE_WS_URL

export function ConnectionStatus() {
  // Only auto-connect if WebSocket is explicitly configured
  // This prevents infinite reconnection loops when WS isn't available
  const { isConnected, isConnecting, error } = useWebSocket({ autoConnect: wsConfigured })

  // Don't show anything if WebSocket is not configured
  if (!wsConfigured) {
    return null
  }

  if (isConnecting) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-yellow-600 dark:text-yellow-400" title="Connecting...">
        <Loader2 className="h-3 w-3 animate-spin" />
        <span className="hidden sm:inline">Connecting</span>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-red-600 dark:text-red-400" title={error}>
        <WifiOff className="h-3 w-3" />
        <span className="hidden sm:inline">Offline</span>
      </div>
    )
  }

  if (isConnected) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-green-600 dark:text-green-400" title="Connected">
        <Wifi className="h-3 w-3" />
        <span className="hidden sm:inline">Live</span>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1.5 text-xs text-gray-400" title="Disconnected">
      <WifiOff className="h-3 w-3" />
      <span className="hidden sm:inline">Offline</span>
    </div>
  )
}
